import { Outlet } from "react-router";

import { Footer } from "@/components/footer";
import { Header } from "@/components/Header";

export function SiteLayout() {
  return (
    <div className="flex min-h-screen flex-col bg-white text-yoyo-text ">
      <Header />
      <main className="flex-1  ">
        <Outlet />
      </main>
      <Footer />
    </div>
  );
}
